import { Placeholder } from '../Placeholder';
export default function StrategyInsightsPage(): JSX.Element {
  return <Placeholder screenNo="7" title="전략 인사이트" description="성과 분해·손절 분석·LLM 리포트." />;
}
